module.exports = __webpack_public_path__ + "static/media/loading22.728bc3ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading22.png
// module id = 207
// module chunks = 0